import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-339ab827"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Visualize transaction activity on two axes: accounts and time. ")
const _hoisted_2 = { class: "flex-grow flex p-3" }
const _hoisted_3 = { class: "flex flex-col items-end pt-2" }
const _hoisted_4 = {
  class: "font-bold h-12 truncate text-green-400",
  style: {"max-width":"12rem"}
}
const _hoisted_5 = { class: "ml-3 pt-5 flex-1 overflow-x-auto flex custom-scrollbar" }
const _hoisted_6 = {
  key: 0,
  class: "-mt-3 flex-1 text-center text-gray-500 italic"
}
const _hoisted_7 = { class: "text-center font-medium" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "From:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "To:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Hash:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Date:", -1))
const _hoisted_13 = { class: "text-center mt-2 text-gray-400" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Transaction Details")
const _hoisted_15 = { class: "relative h-12 z-10 border-t-2 border-green-400 dark:border-green-600" }
const _hoisted_16 = {
  key: 0,
  class: "absolute h-full right-0 border-r border-gray-200 dark:border-gray-700"
}
const _hoisted_17 = {
  key: 0,
  class: "absolute h-full right-0 border-r border-gray-200 dark:border-gray-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionIcon = _resolveComponent("ActionIcon")!
  const _component_account_link = _resolveComponent("account-link")!
  const _component_external_link = _resolveComponent("external-link")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    title: "Transaction History",
    embed: "embed:transaction-history"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentAccount), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mostInteractedAccounts, (account) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "font-medium h-12 truncate",
              style: {"max-width":"12rem"},
              key: account
            }, _toDisplayString(account), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.mostInteractedActions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Nothing to show. "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mostInteractedActions, (action, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: action,
              class: "relative w-12 flex-shrink-0"
            }, [
              (action.receiver_account_id !== action.signer_account_id)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: "absolute left-1/2 transform -translate-x-1/2 w-0.5 bg-gray-500 dark:bg-gray-300 z-10",
                      style: _normalizeStyle({
                  top:
                    (Math.min(
                      _ctx.mostInteractedAccounts.indexOf(action.signer_account_id),
                      _ctx.mostInteractedAccounts.indexOf(
                        action.receiver_account_id,
                      ),
                    ) +
                      1) *
                      3 +
                    'rem',
                  height:
                    (Math.max(
                      _ctx.mostInteractedAccounts.indexOf(action.signer_account_id),
                      _ctx.mostInteractedAccounts.indexOf(
                        action.receiver_account_id,
                      ),
                    ) +
                      1) *
                      3 +
                    'rem',
                })
                    }, null, 4),
                    _createElementVNode("div", {
                      class: "absolute w-3 h-3 rounded-full transform -translate-y-1/2 -translate-x-1/2 left-1/2 bg-green-400 border-2 border-white dark:border-gray-800 z-20",
                      style: _normalizeStyle({
                  top:
                    (_ctx.mostInteractedAccounts.indexOf(action.signer_account_id) +
                      1) *
                      3 +
                    'rem',
                })
                    }, null, 4)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_Tooltip, {
                class: "absolute w-8 h-8 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-30 rounded-full",
                style: _normalizeStyle({
                top:
                  (_ctx.mostInteractedAccounts.indexOf(action.receiver_account_id) +
                    1) *
                    3 +
                  'rem',
              })
              }, {
                trigger: _withCtx(({ open }) => [
                  _createVNode(_component_ActionIcon, {
                    class: _normalizeClass(["w-8 h-8 border-2 border-white dark:border-gray-800 transform transition-all duration-75", {
                    'scale-125 filter drop-shadow-sm': open,
                  }]),
                    action: action,
                    transactionStyle: "generic"
                  }, null, 8, ["class", "action"])
                ]),
                content: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.$filters.humanize.actionKind(action.action_kind)), 1),
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_9,
                        _createElementVNode("td", null, [
                          _createVNode(_component_account_link, {
                            theme: "dark",
                            account: action.signer_account_id
                          }, null, 8, ["account"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_10,
                        _createElementVNode("td", null, [
                          _createVNode(_component_account_link, {
                            theme: "dark",
                            account: action.receiver_account_id
                          }, null, 8, ["account"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_11,
                        _createElementVNode("td", null, _toDisplayString(action.transaction_hash), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_12,
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.nearTimestampToLocaleString(
                            action.block_timestamp,
                            _ctx.DateTime.DATETIME_FULL,
                          )), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_13, [
                    _createVNode(_component_external_link, {
                      href: 
                      _ctx.networks[_ctx.network].explorer +
                      '/transactions/' +
                      action.transaction_hash
                    ,
                      class: "underline"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["href"])
                  ])
                ]),
                _: 2
              }, 1032, ["style"]),
              _createElementVNode("div", _hoisted_15, [
                (i !== _ctx.mostInteractedActions.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mostInteractedAccounts, (account, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: account,
                  class: "relative flex justify-center h-12 border-t-2 border-gray-200 dark:border-gray-700"
                }, [
                  (
                  i !== _ctx.mostInteractedActions.length - 1 &&
                  j !== _ctx.mostInteractedAccounts.length - 1
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}